import { Button } from "@dash/form";
import { HeaderBar } from "@dash/page";
import { MdCancel, MdOpenInNew } from "react-icons/md";

import { Order } from "@megaron/fulfillment-contracts";

import { getShopifyOrderUrl } from "./constants";
import { shouldShowShopifyCancelButton } from "./orderPackingUtils";

type Props = {
  orderData: Order;
  onOpenCancelShopify: () => void;
};

export const OrderPackingHeaderBar = ({ orderData, onOpenCancelShopify }: Props) => (
  <HeaderBar
    header={`WEB-${orderData.orderNumber}`}
    actions={
      <>
        {shouldShowShopifyCancelButton(orderData) && (
          <Button
            variant="outline"
            color="inverse"
            size="small"
            icon={<MdCancel />}
            onClick={onOpenCancelShopify}
          >
            Zwrot / anuluj
          </Button>
        )}
        <a
          href={getShopifyOrderUrl(orderData.id)}
          target="_blank"
          rel="noopener noreferrer"
          css={{
            display: "inline-flex",
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <Button variant="outline" color="inverse" size="small" icon={<MdOpenInNew />} as="div">
            Shopify
          </Button>
        </a>
      </>
    }
  />
);
